import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import _BaseLabel from './_BaseLabel'

export type HighlightLabelVariant =
  | 'primaryNormal'
  | 'primaryLight'

const HighlightLabelElement = styled(_BaseLabel)`
  &.variant-primaryNormal {
    background-color: ${props => props.theme.palette.highlight.primary.normalBackground};
    border-color: ${props => props.theme.palette.highlight.primary.normalForeground};
    color: ${props => props.theme.palette.highlight.primary.normalContrast};
  }

  &.variant-primaryLight {
    background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
    border-color: ${props => props.theme.palette.highlight.primary.lightForeground};
    color: ${props => props.theme.palette.highlight.primary.lightContrast};
  }
`

interface Props {
  variant: HighlightLabelVariant
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof _BaseLabel>['format']
}

/**
 * Documentation: <https://aussiecommerce.atlassian.net/wiki/spaces/UXUI/pages/4504289338/Label>
 */
function HighlightLabel({ className, variant, ...labelProps }: PropsWithChildren<Props>) {
  return <HighlightLabelElement
    className={clsx(
      className,
      `variant-${variant}`,
    )}
    {...labelProps}
  />
}

export default HighlightLabel
